import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
// import { connect,useSelector, } from 'react-redux';
import { Link } from 'react-router-dom';
import { getLandingReviews } from '../../../actions';
import Item from '../../../item';
import { appConstants } from '../../../helpers/app-constants';
import isEmpty from "../../../isEmpty";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "../../../index.css";

function Review(props) {

  const { landreviews } = useSelector((state) => {

    return state.Home;
  });

  const dispatch = useDispatch();

  const [section, SetSection] = useState([]);
  const [responsive, SetResponsive] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 550, min: 1 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  });

  const [responsive2, SetResponsive2] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 768, min: 1 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  });
  const [heading, SetHeading] = useState("");
  const [slides, SetSlides] = useState([]);
  const [sliderSpeed, SetSliderSpeed] = useState(0);

  useEffect(() => {
    // dispatch(getLanuageList());
    dispatch(getLandingReviews(props.itemid));

  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(landreviews)) {
      const items = landreviews.items;
      const slides = landreviews.reviews;
      if (!isEmpty(items)) {
        SetHeading(items[0].name_en);
        SetSliderSpeed(items[1].name_en);

      }

      if (!isEmpty(slides)) {
        SetSlides(slides);
      }

    }
  }, [landreviews]);

  return (
    <section className="section_space buytravel_outer testimonial_outer">
      <div className="container custom_container">
        <div className="row">
          <div className="col-md-12">
            <div className="agent_title buytravel_title aos-item" data-aos="fade-up">{heading}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Carousel
              responsive={responsive2}
              additionalTransfrom={0}
              arrows
              autoPlay={true}
              autoPlaySpeed={parseInt(sliderSpeed)}
              centerMode={false}
              draggable
              focusOnSelect={false}
              infinite
              keyBoardControl
              minimumTouchDrag={80}
              renderButtonGroupOutside={false}
              renderDotsOutside={false}
              showDots
              sliderClass=""
              slidesToSlide={1}
              swipeable
              containerclassName="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile"]}
              deviceType={props.deviceType}
              dotListclassName="rec-dot"
              itemclassName="carousel-item-padding-40-px"  >
              {slides.map((item, index) => (
                <div className="buyer_inner aos-item" key={index} data-aos="fade-right">
                  <div id="full-stars-example-two1">
                    <div className="rating-group">
                      <label aria-label="1 star" className="rating__label active" for="rating3-1"><i className="rating__icon rating__icon--star fa fa-star"></i></label>

                      <label aria-label="2 stars" className={item.rating > 1 ? " rating__label active" : "rating__label"} for="rating3-2"><i className="rating__icon rating__icon--star fa fa-star"></i></label>

                      <label aria-label="3 stars" className={item.rating > 2 ? " rating__label active" : "rating__label"} for="rating3-3"><i className="rating__icon rating__icon--star fa fa-star"></i></label>

                      <label aria-label="4 stars" className={item.rating > 3 ? " rating__label active" : "rating__label"} for="rating3-4"><i className="rating__icon rating__icon--star fa fa-star"></i></label>

                      <label aria-label="5 stars" className={item.rating > 4 ? " rating__label active" : "rating__label"} for="rating3-5"><i className="rating__icon rating__icon--star fa fa-star"></i></label>
                    </div>
                  </div>
                  <div className="buyer_title">{item.name_en}</div>
                  <div className="client_title">— {item.author_name} </div>
                </div>
              ))}

            </Carousel>

          </div>
        </div>
      </div>
    </section>
  )
}

export { Review };

